import { AsyncPipe, Location, UpperCasePipe } from '@angular/common';
import { Component, EventEmitter, Input, Output, inject } from '@angular/core';
import { TranslocoPipe } from '@jsverse/transloco';
import { SavingsPlanFacade } from '@zero/saving-plans/domain';
import { ContractConfirmationFacade } from '@zero/shared/feature-contract-confirmation/base';
import { MicarContractsNudgingComponent } from '@zero/shared/feature-contract-confirmation/web';
import { ButtonComponent } from '@zero/shared/ui-web-design-system';
import { CustomerStateFacade } from '@zero/shared/util-global-state';
import { Asset, InstrumentType } from '@zero/shared/util-models';
import { CheckExperienceAndFtgComponent } from '@zero/trade/feature-trade/web';
import { DonauCapitalHintComponent } from '../donau-capital-hint/donau-capital-hint.component';
import { SavingsPlanCreateListComponent } from './savings-plan-create-list/savings-plan-create-list.component';
import { SavingsPlanCryptoHintComponent } from './savings-plan-crypto-hint/savings-plan-crypto-hint.component';
import { SavingsPlanOptionsComponent } from './savings-plan-options/savings-plan-options.component';
import { SavingsPlansSumComponent } from './savings-plans-sum/savings-plans-sum.component';

@Component({
  selector: 'saving-plans-create',
  imports: [
    TranslocoPipe,
    AsyncPipe,
    SavingsPlanOptionsComponent,
    SavingsPlanCryptoHintComponent,
    SavingsPlanCreateListComponent,
    SavingsPlansSumComponent,
    ButtonComponent,
    UpperCasePipe,
    CheckExperienceAndFtgComponent,
    MicarContractsNudgingComponent,
    DonauCapitalHintComponent,
  ],
  templateUrl: './savings-plan-create.component.html',
})
export class SavingsPlanCreateComponent {
  @Input() public assets: Asset[] = [];

  @Output() public noWalletWarningClick = new EventEmitter();
  @Output() public goNext = new EventEmitter();

  public readonly location = inject(Location);
  public readonly savingsPlanFacade = inject(SavingsPlanFacade);
  public readonly customerStateFacade = inject(CustomerStateFacade);
  public readonly contractConfirmationFacade = inject(ContractConfirmationFacade);
  public acceptCryptoRisk = false;

  public get hasCryptoAsset(): boolean {
    return this.assets.some((asset) => asset?.instrumentType === InstrumentType.Crypto);
  }

  public get lastCryptoAsset(): Asset | undefined {
    return this.assets.find((asset) => asset?.instrumentType === InstrumentType.Crypto);
  }

  public acceptRisk(accept: boolean): void {
    this.acceptCryptoRisk = accept;
  }
}
